<template>
  <div class="settings-hotkeys">
    <!-- <div style="max-width: 30rem" class="d-flex mt-8"> -->
    <v-btn
      class="mb-4"
      @click="reset"
    >
      <i class="mr-2 mdi mdi-replay text-semi-large"></i>
      {{ $t('btn.reset_default') }}
    </v-btn>
    <!-- </div> -->
    <div
      v-for="(item, i) in options"
      :key="i"
      class="settings-hotkeys_hotkey"
    >
      <div
        v-if="item.title"
        class="clr-grey text-medium"
        :class="item.css_class"
      >
        {{ item.title }}
      </div>
      <div
        v-for="(ooo, idx) in item.opts"
        :key="idx"
        class="d-flex editable-cont"
        :class="{ dupl: ooo.isDuplicate }"
      >
        <div
          class="settings-hotkeys_hotkey_text"
          style="width: 300px; max-width: calc(100vw - 11rem)"
        >
          {{ ooo.name }}
        </div>
        <div
          v-if="ooo.img || ooo.sub"
          class="csst mdi mdi-help-circle-outline clr-grey my-auto mr-2"
          @mouseenter="fl_positionTooltip"
        >
          <div
            class="csst_content clr-white"
            style="position: fixed"
          >
            <div
              v-if="ooo.sub"
              style="max-width: 24rem"
              v-html="$t(`hotkeys.${ooo.sub}`)"
            ></div>
            <img
              v-if="ooo.img"
              :style="ooo.img_style"
              class="hotkeys-help-img"
              :src="getImage(ooo.img)"
            />
          </div>
        </div>
        <div
          class="settings-hotkeys_hotkey_key f-center position-relative"
          :class="[
            { 'no-events': ooo.noevents },

            {
              'anim-shake settings-hotkeys_hotkey_key_error': shakeId === ooo.id,
            },
          ]"
          style="--anim-iteration: 1"
        >
          {{ ooo.displayCombination }}
          <div
            v-if="!ooo.noevents"
            class="hokeys-input text-center"
          >
            <span class="hokeys-input_value uppercase">
              {{ ooo.displayCombination }}
            </span>
            <!-- @blur="(e) => handleFocus({ e, item: ooo, index: ooo.idx })" -->
            <input
              autocomplete="false"
              spellcheck="false"
              type="text"
              :name="ooo.key"
              @blur="e => handleBlur({ e, item: ooo, index: ooo.idx })"
              @focus="e => handleFocus({ e, item: ooo, index: ooo.idx })"
              @keydown.prevent="e => handleKeydown({ e, item: ooo, index: ooo.idx })"
              @keyup.prevent="e => handleKeyup({ e, item: ooo, index: ooo.idx })"
            />
            <label
              class="text-smallest"
              :for="ooo.key"
            >
              {{ shakeId === ooo.id ? $t('messages.available_keys') : $t('hotkeys.press_keys') }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import { defaultHotkeys, getHotkeyCode, getHotkeysConf } from '@/store/userSettings/hotkeys'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'SettingsHotkeys',
  mixins: [float_mix],
  data() {
    return {
      l_hotkeys: {},
      conf: {
        // reset_history: { gId: 'global', sub: 'reset_history_sub' },
        switch_pot_bb: {
          gId: 'global',
          img: 'switch_between_pot.webp',
          img_style: 'max-height:10rem',
        },
        switch_ev_pot: {
          gId: 'global',
          img_style: 'max-height:10rem',
          name: this.$t('hotkeys.switch_ev_pot_tra01'),
        },
        drawing_mode: { gId: 'global', sub: 'drawing_mode_sub' },
        focus_mode: { gId: 'global', sub: 'focus_mode_sub' },
        reset_history: { gId: 'global', sub: 'reset_history_sub' },
        open_shortcuts: { gId: 'global', sub: 'open_shortcuts_sub' },
        switch_actions_grouping: { gId: 'global', img: 'action_grouping_chart_switch.webp' },

        study_switch_strategy: {
          gId: 'study',
          noevents: true,
          displayCombination: '1 (+Shift)',
          sub: 'study_switch_strategy_sub',
          img: 'switch_strategy_tab.webp',
        },
        study_to_switch_strategy: {
          gId: 'study',
          noevents: true,
          displayCombination: '1 2 3 4',
          img: 'switch_strategy_tabs.webp',
        },
        study_switch_street_card: {
          gId: 'study',
          noevents: true,
          displayCombination: 'Shift + Arrow',
          sub: 'study_switch_street_card_sub',
        },
        study_switch_gmf: {
          gId: 'study',
          noevents: true,
          displayCombination: 'Up, Down',
          sub: 'study_switch_gmf_sub',
        },
        study_hspot_jump: {
          gId: 'study',
          noevents: true,
          displayCombination: 'Right, Left',
          sub: 'study_hspot_jump_sub',
        },

        study_fullscreen_mode: { gId: 'study', img: 'fullscreen_mode.webp' },
        study_reports_turn_view: { gId: 'study', img: 'switch_table_chart_reports.webp' },
        study_reset_filters: { gId: 'study', sub: 'study_reset_filters_sub' },
        expand_history: { gId: 'study', name: this.$t('common.expand_collapse_history') },
        save_spot: { gId: 'study', name: this.$t('hotkeys.save_spot_tra01') },

        action_call: { gId: 'trainer' },
        action_check_fold: { gId: 'trainer' },
        action_allin: { gId: 'trainer' },
        _123: {
          gId: 'trainer',
          noevents: true,
          displayCombination: '1 2 3 4 5 6 7 8 9',
          sub: '_123_sub',
        },
        cancel_selected_action: { gId: 'trainer', noevents: true, displayCombination: 'Escape' },
        practice_next_hand: { gId: 'trainer', noevents: true, displayCombination: 'Enter' },
        practice_replay_hand: { gId: 'trainer' },
        practice_play_new_hand: { gId: 'trainer' },
        practice_hero_frequency: { gId: 'trainer' },
        practice_full_hand_next_spot: {
          gId: 'trainer',
          noevents: true,
          displayCombination: 'Right',
        },
        practice_full_hand_previous_spot: {
          gId: 'trainer',
          noevents: true,
          displayCombination: 'Left',
        },
        practice_full_hand_next_table: {
          gId: 'trainer',
          noevents: true,
          displayCombination: 'Down',
        },
        practice_full_hand_previous_table: {
          gId: 'trainer',
          noevents: true,
          displayCombination: 'Up',
        },
        practice_study_spot: { gId: 'trainer' },

        // practice_builder_focus_action: { gId: 'builder', noevents: true, displayCombination: 'Tab' },
        // practice_builder_lock_paint: { gId: 'builder', noevents: true, displayCombination: 'Shift' },
        practice_builder_history_undo: {
          gId: 'builder',
          noevents: true,
          displayCombination: 'Control + Z',
        },
        practice_builder_history_redo: {
          gId: 'builder',
          noevents: true,
          displayCombination: 'Control + Y',
        },

        hand_replay_next_hand: { gId: 'analyze', noevents: true, displayCombination: 'Down' },
        hand_replay_previous_hand: { gId: 'analyze', noevents: true, displayCombination: 'Up' },
        hand_replay_next_spot: { gId: 'analyze', noevents: true, displayCombination: 'Right' },
        hand_replay_previous_spot: { gId: 'analyze', noevents: true, displayCombination: 'Left' },

        // practice_builder_focus_action: { },
      },
      // shakeId: 'study_to_switch_strategy',
      shakeId: '',
      // setNewCombination: '',
      newCombination: [],
      oldCombination: [],
    }
  },
  methods: {
    setLocalHokeys(hotkeys) {
      hotkeys = hotkeys || this.hotkeys
      const res = {}
      Object.keys(this.conf).forEach(actionName => {
        const hotkeyConf = hotkeys[actionName]
        res[actionName] = {
          ...this.conf[actionName],
          ...hotkeyConf,
        }
      })
      this.l_hotkeys = res
    },
    persitHotkeys() {
      nextTick(() => {
        if (!this.options.some(i => i.opts.some(oo => oo.isDuplicate))) {
          // debugger
          const patchData = {}
          Object.keys(defaultHotkeys()).forEach(key => {
            if (this.l_hotkeys[key]) {
              patchData[key] = this.l_hotkeys[key].keyCombination
            }
          })
          this.$store.dispatch('setHotkeys', { patchData })
        }
      })
    },
    handleFocus({ e, item, index }) {
      this.newCombination = []
      this.oldCombination = this.l_hotkeys[item.id].keyCombination
      this.l_hotkeys[item.id] = {
        ...this.l_hotkeys[item.id],
        keyCombination: [],
        displayCombination: '',
      }
    },
    handleBlur({ e, item, index }) {
      if (!this.l_hotkeys[item.id].keyCombination.length) {
        const displayCombination = this.oldCombination.map(k => k.replace('Key', '')).join('+')
        this.l_hotkeys[item.id] = {
          ...this.l_hotkeys[item.id],
          keyCombination: this.oldCombination,
          displayCombination,
        }
      }
    },
    handleKeydown({ e, item, index }) {
      e.preventDefault()
      if (this.newCombination?.length > 3) return
      const code = getHotkeyCode(e)
      if (!e.code.includes('Key') && code !== 'space' && code !== 'shift') {
        this.shakeId = item.id
        setTimeout(() => {
          this.shakeId = ''
        }, 2222)
        return
      }

      this.newCombination = [...new Set([...this.newCombination, code])]

      const displayCombination = this.newCombination.map(k => k.replace('Key', '')).join('+')
      this.l_hotkeys[item.id] = {
        ...this.l_hotkeys[item.id],
        keyCombination: this.newCombination,
        displayCombination,
      }
      // this.setNewCombination = ''
    },
    handleKeyup({ e, item, index }) {
      const code = getHotkeyCode(e)
      // this.setNewCombination = item.id
      this.newCombination = this.newCombination.filter(c => c !== code)
      if (!this.newCombination.length) {
        this.persitHotkeys()
        // setTimeout(() => {
        e.target.blur()
        // }, 100)
      }
    },
    reset() {
      this.$store.dispatch('resetHotkeys')
      const hotkeys = getHotkeysConf({ apiConf: defaultHotkeys() })
      this.setLocalHokeys(hotkeys)
    },
    getImage(img) {
      return new URL(`/src/assets/img/howto/${img}`, import.meta.url).href
    },
  },
  computed: {
    hotkeys() {
      return this.$store.getters.hotkeys
    },
    options() {
      let res = this.l_hotkeys
      res = Object.keys(res).map(k => ({
        ...res[k],
        id: k,
      }))
      res = res.map((i, idx) => {
        const duplicates = this.newCombination.length
          ? false
          : res.filter((ht, htIdx) => {
              if (idx === res.findIndex(htt => htt.id === ht.id)) return true

              const itemCombination = i.keyCombination
              const someCombination = ht.keyCombination
              if (itemCombination && someCombination?.length === itemCombination?.length) {
                const duplicate = someCombination.filter(
                  keyCode => !itemCombination.includes(keyCode),
                )
                return duplicate.length === 0
              }
              return false
            })
        const r = {
          ...i,
          idx,
          name: i.name || this.$t(`hotkeys.${i.id}`),
          isDuplicate: !i.noevents && duplicates.length > 1,
        }
        return r
      })

      res = [
        { gId: 'global', component: 'title', title: this.$t('common.global') },
        { gId: 'study', component: 'title', title: this.$t('links.study_dashboard') },
        { gId: 'builder', component: 'title', title: this.$t('links.practice_range_builder') },
        { gId: 'analyze', component: 'title', title: this.$t('links.analyze_replayer') },
        { gId: 'trainer', component: 'title', title: this.$t('links.practice_trainer') },
      ].map(i => {
        const r = {
          ...i,
          opts: res.filter(e => e.gId === i.gId),
        }
        return r
      })
      // console.log(res)
      return res
    },
  },
  watch: {
    hotkeys: {
      immediate: true,
      handler: 'setLocalHokeys',
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 1366px) {
  .settings-hotkeys {
    display: block !important;
  }
}
.dupl {
  box-shadow: 0px 0px 1px 1px red;
  // border-radius: 2px;
  opacity: 0.95;
}

.hokeys-input {
  position: absolute;
  width: calc(100% - 2rem);
  transform: scale(1.1);
  background: rgb(47, 47, 47);
  color: black;
  caret-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border-radius: 99px;
  height: 60%;
  min-height: 32px;
  &_value {
    color: var(--clr-white-0);
    position: absolute;
    z-index: 1;
  }

  &:hover {
    background: var(--clr-black-1);
    opacity: 1 !important;
    color: var(--clr-white-0);
  }

  label {
    opacity: 0;
    z-index: 2;
    position: absolute;
    top: -0.6rem;
    letter-spacing: 0.5px;
    padding: 0 2px;
    color: var(--clr-white-0);
    transition: 0.2s;
    text-shadow: 0 0 2px black;
    font-weight: 700;
  }
  input {
    color: transparent;
    font-size: 0.875rem;
    position: relative;
    z-index: 2;
    cursor: pointer;
    position: relative;
    z-index: 1;
    text-align: center;
    width: 100%;
    border-radius: 99px;
    height: 100%;
    border: solid 1px var(--clr-border);
    &:focus {
      --clr-border: var(--clr-primary);
      + label {
        opacity: 1;
      }
    }
  }
}

.settings-hotkeys {
  display: flex;
  flex-direction: column;
  max-width: 42rem;
  overflow-x: hidden;
  overflow-y: auto;
  &_hotkey {
    font-size: 1rem;
    margin: 0 0 1rem 0;
    color: var(--clr-white-0);
    &_key {
      max-width: 10rem;
      min-width: 10rem;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      min-height: 3.25rem;
      z-index: 1;
      position: relative;
      margin-left: auto;
      font-weight: 500;
      text-align: center;
      padding: 0 0.5rem;
      --clr-border: var(--clr-black-3);
      &_error {
        --clr-border: var(--clr-error);
        opacity: 1 !important;
        .hokeys-input_value {
          opacity: 0;
        }
        label {
          opacity: 1;
          color: var(--clr-border);
          top: 0.5rem;
        }
      }
    }
    &_text {
      padding: 0.25rem 1rem;
      align-items: center;
      display: flex;
    }
  }
}

.hotkeys-help-img {
  height: 21rem;
  border-radius: 4px;
  overflow: hidden;
  margin: 0.325rem 0 0 0;
}

.editable-cont {
  position: relative;
  width: 100%;
  margin-top: 4px;
  border-bottom: solid 1px var(--clr-black-2);
  &:hover {
    .hokeys-input {
      pointer-events: all;
      z-index: 1;
      input {
        opacity: 1;
      }
    }
  }
}
</style>
